import { Skeleton } from '@/components/ui';

function TaskCardSkeleton() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
      <Skeleton className="h-5 w-5 rounded shrink-0 mt-0.5" />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}

function EventCardSkeleton() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
      <Skeleton className="h-10 w-1 rounded-full shrink-0" />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}

/**
 * Content-only skeleton for TodayTab.
 * Headers (hamburger, date, greeting, pills) render as real components above this.
 */
export function TodayTabSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      {/* Section heading */}
      <Skeleton className="h-4 w-20" />

      <TaskCardSkeleton />
      <EventCardSkeleton />
      <TaskCardSkeleton />
      <EventCardSkeleton />
    </div>
  );
}
